module.exports = __webpack_public_path__ + "img/zenbook3-deluxe.0441d913.jpg";